export const etEstonian = {
    "Pensil Keyword": "Estonian",
    "Home": "Kodu",
    "Explore Groups": "Uurige gruppe",
    "Events": "Sündmused",
    "Groups": "Grupid",
    "Links": "Lingid",
    "Direct Message": "Otsesõnum",
    "Powered by": "Powered by",
    "No groups here, please use + to create a new one, or join one see them here.": "Siin pole gruppe. Kasutage uue loomiseks nuppu + või liituge, vaadake neid siin.",
    "Please join a group to see them here": "Liituge grupiga, et neid siin näha",
    "Section can only be reordered within the group!": "Sektsiooni saab ümber tellida ainult grupisiseselt!",
    "Group Page": "Grupi leht",
    "Invite Members": "Kutsuge liikmeid",
    "Join": "Liitu",
    "Joined": "Liitunud",
    "Create new section": "Loo uus jaotis",
    "Group Setting drop down": "Rühma seadistuste rippmenüü",
    "Share": "Jaga",
    "Edit group": "Redigeeri gruppi",
    "Delete group": "Kustuta grupp",
    "Leave": "Lahku",
    "Are you sure you want to delete the group?": "Kas olete kindel, et soovite grupi kustutada?",
    "Cancel": "Tühista",
    "Yes, Go Ahead": "Jah, jätkake",
    "Share via link": "Jaga lingi kaudu",
    "Copy": "Kopeeri",
    "Copied": "Kopeeritud",
    "Share on social media": "Jaga sotsiaalmeedias",
    "Add Section": "Lisa jaotis",
    "Section Header": "Jaotise päis",
    "Live": "Otse",
    "Create Post": "Loo postitus",
    "Notificaiton Bell": "Teavituskell",
    "All posts": "Kõik postitused",
    "Admin posts only": "Ainult administraatori postitused",
    "None": "Mitte ühtegi",
    "Section Setting drop down": "Jaotise Seade rippmenüü",
    "Edit Section": "Redigeeri jaotist",
    "Embed Section": "Manusta jaotis",
    "Delete Section": "Kustuta jaotis",
    "Are you sure you want to delete the section?": "Kas olete kindel, et soovite jaotise kustutada?",
    "Section deleted!": "Jaotis kustutatud!",
    "Create Group Pop up / Update": "Loo rühma hüpikaken / Värskenda",
    "Create group": "Loo grupp",
    "Basic Detail": "Põhidetail",
    "Settings": "Seaded",
    "Size 16:9 or 1600 by 900": "Suurus 16:9 või 1600 x 900",
    "Group name": "Grupi nimi",
    "Enter group name": "Sisestage rühma nimi",
    "Suggestions: Spaces, Channels, Groups, Blog, Knowledgebase, etc": "Soovitused: ruumid, kanalid, rühmad, ajaveeb, teadmistebaas jne",
    "Group Description": "Grupi kirjeldus",
    "Enter description here": "Sisesta kirjeldus siia",
    "Group Type": "Grupi tüüp",
    "Open": "Avatud",
    "Visible to all & anyone can join": "Nähtav kõigile ja kõik saavad liituda",
    "Closed": "Suletud",
    "User will have to request to join the group": "Kasutaja peab taotlema grupiga liitumist",
    "Paid": "Tasuline",
    "Group Price": "Grupi hind",
    "Currency (Default: INR)": "Valuuta (vaikimisi: INR)",
    "User will have to pay to join the group": "Kasutaja peab grupiga liitumiseks maksma",
    "Make this a private group": "Muutke see privaatseks grupiks",
    "Private group will only be visible to members who are part of it. Admin can add members manually from member list": "Privaatne grupp on nähtav ainult sellesse kuuluvatele liikmetele. Administraator saab liikmeid liikmete loendist käsitsi lisada",
    "Upload from device": "Laadige seadmest üles",
    "Search image": "Otsi pilti",
    "Valid group name required!": "Nõutav kehtiv grupi nimi!",
    "Update Group": "Värskenda gruppi",
    "SEO Settings": "SEO seaded",
    "Custom URL": "Kohandatud URL",
    "Meta Title": "Meta pealkiri",
    "Maximum length of 255 characters allowed": "Maksimaalne lubatud pikkus on 255 tähemärki",
    "Meta Description": "Meta kirjeldus",
    "Open Graph Detail": "Avage graafiku üksikasjad",
    "Open Graph Title": "Avage graafiku pealkiri",
    "Open Graph Description": "Avage graafiku kirjeldus",
    "Open Graph Image": "Avage graafiku pilt",
    "Recommended dimensions: 1200px by 630px with a 1.91:1 aspect ratio.": "Soovitatavad mõõtmed: 1200 x 630 pikslit kuvasuhtega 1,91:1.",
    "If no URL is used, it will automatically picked your group thumbnail.": "Kui URL-i ei kasutata, valib see automaatselt teie rühma pisipildi.",
    "Create Section Pop up / Update": "Loo jaotise hüpikaken / Värskenda",
    "Create Section": "Loo jaotis",
    "Section Name": "Sektsiooni nimi",
    "Suggestions: General, Introductions, Community Guidelines": "Soovitused: Üldine, Sissejuhatus, Kogukonna juhised",
    "Section Type": "Sektsiooni tüüp",
    "Post Type": "Postituse tüüp",
    "Group Chat": "Grupivestlus",
    "Who can post in this section?": "Kes saavad sellesse jaotisesse postitada?",
    "Only Admin": "Ainult Admin",
    "Any user": "Iga kasutaja",
    "Sorting order for section": "Jaotise sortimisjärjekord",
    "Latest first": "Kõigepealt viimane",
    "Oldest post first": "Kõigepealt vanim postitus",
    "Section Appearance": "Sektsiooni välimus",
    "List View": "Loendivaade",
    "Grid View": "Võrguvaade",
    "Make this closed section": "Tehke see suletud osa",
    "Members will have to request access to see section content": "Liikmed peavad jaotise sisu nägemiseks taotlema juurdepääsu",
    "Make this a private section": "Muutke see privaatseks jaotiseks",
    "Disables requests (Make sure closed section is selected as well).": "Keelab päringud (veenduge, et valitud oleks ka suletud jaotis).",
    "Post Editor": "Postituse toimetaja",
    "Create new post in": "Loo uus postitus",
    "Add Cover Picture": "Lisa kaanepilt",
    "Heading (Optional)": "Pealkiri (valikuline)",
    "Write here..": "Kirjuta siia..",
    "Picture": "Pilt",
    "Video": "Video",
    "Attachment": "Manus",
    "Poll": "Küsitlus",
    "Embed Code": "Manusta kood",
    "Tags": "Sildid",
    "Toggle to question": "Lülitage küsimusele sisse",
    "Poll expire time": "Küsitluse aegumisaeg",
    "Poll question": "Küsitluse küsimus",
    "Enter Question": "Sisestage küsimus",
    "Question": "küsimus",
    "Option": "Võimalus",
    "Options": "Valikud",
    "Add Option": "Lisa valik",
    "Poll Expiry time": "Küsitluse aegumisaeg",
    "12 Hours": "12 tundi",
    "1 Day": "1 päev",
    "2 Days": "2 päeva",
    "1 Week": "1 nädal",
    "2 Weeks": "2 nädalat",
    "Always Open": "Alati avatud",
    "Write embeddable code": "Kirjutage manustatav kood",
    "Click here to add embed code.": "Manustuskoodi lisamiseks klõpsake siin.",
    "Paste your embed code here!": "Kleepige oma manustamiskood siia!",
    "Post Settings": "Postituse seaded",
    "Update Post": "Värskenda postitust",
    "Update": "Värskenda",
    "Start meeting / Video call / Live": "Alustage koosolekut / videokõnet / reaalajas",
    "Meeting Name": "Koosoleku nimi",
    "Suggestion: Group discussion etc": "Soovitus: Rühmaarutelu jne",
    "Description": "Kirjeldus",
    "Enter description here (optional)": "Sisestage siia kirjeldus (valikuline)",
    "When do you want to start the session": "Millal soovite seanssi alustada",
    "Right now": "Kohe praegu",
    "Schedule for later": "Ajakava hilisemaks",
    "Group video call": "Grupi videokõne",
    "Webinar": "Veebiseminar",
    "Go Live": "Minge otseülekandesse",
    "Info on the Post": "Info Postituses",
    "Post comment": "Postita kommentaar",
    "Comment": "kommenteerida",
    "Comments": "Kommentaarid",
    "Reply": "Vasta",
    "Replies": "Vastused",
    "Share via URL": "Jaga URL-i kaudu",
    "Reshare in other sections": "Jagage edasi teistes jaotistes",
    "Post Card Drop Down": "Postkaardi rippmenüü",
    "Bookmark": "Järjehoidja",
    "Pin post": "Kinnitage postitus",
    "Edit": "Muuda",
    "Embed Post": "Manusta postitus",
    "Delete": "Kustuta",
    "Remove Pin": "Eemalda Pin",
    "Remove Bookmark": "Eemalda järjehoidja",
    "Just copy paste this code wherever you want it to be embedded": "Lihtsalt kopeerige ja kleepige see kood kuhu iganes soovite selle manustada",
    "Height": "Kõrgus",
    "Preview": "Eelvaade",
    "Copied to clipboard": "Kopeeriti lõikelauale",
    "Select Widgets": "Valige Vidinad",
    "Add widgets to": "Lisa vidinaid",
    "You can change their order by dragging & dropping the widgets over each other": "Saate nende järjekorda muuta, pukseerides vidinaid üksteise peale",
    "Please note: Widget wont be displayed if there is no data available,": "Pange tähele: vidinat ei kuvata, kui andmed puuduvad,",
    "Group Members": "Grupi liikmed",
    "Group Leaderboard": "Grupi edetabel",
    "Community Leaderboard": "Kogukonna edetabel",
    "Trending Posts": "Populaarsed postitused",
    "Group Events": "Grupiüritused",
    "Add Custom": "Lisa kohandatud",
    "Save Widgets": "Salvesta vidinad",
    "Visible to user": "Kasutajale nähtav",
    "Visible to admin": "Nähtav administraatorile",
    "Add widget to": "Lisa vidin",
    "Upload cover picture": "Laadi üles kaanepilt",
    "1:1 aspect ration (recommended)": "1:1 kuvasuhe (soovitatav)",
    "Card Title": "Kaardi pealkiri",
    "Enter widget name": "Sisestage vidina nimi",
    "Small Description (try to keep it under 50 words)": "Väike kirjeldus (proovige hoida seda alla 50 sõna)",
    "Enter description": "Sisesta kirjeldus",
    "Button Title": "Nupu pealkiri",
    "Enter button name": "Sisestage nupu nimi",
    "Siggestion: Know more, Join, Apply, etc": "Soovitus: teadke rohkem, liituge, kandideerige jne",
    "URL link": "URL-i link",
    "Create custom widget": "Loo kohandatud vidin",
    "Custom widget created successfully": "Kohandatud vidin on edukalt loodud",
    "Widgets": "Vidinad",
    "Members": "liikmed",
    "See All": "Vaata kõiki",
    "Communtiy Top Contributors": "Kogukonna tipp-panustajad",
    "Community Members": "kogukonna liikmed",
    "Group Top Contributors": "Rühma suurimad panustajad",
    "Upcoming Events": "Eelseisvad sündmused",
    "Home Page Banner": "Kodulehe bänner",
    "Edit Banner": "Redigeeri bännerit",
    "Home page Edit Banner Pop up": "Avaleht Redigeeri bänneri hüpikaken",
    "Update Banner": "Värskenda bännerit",
    "Search": "Otsi",
    "Upload Image": "Laadi pilt üles",
    "Remove": "Eemalda",
    "Banner image (please use 16:6 ratio or 1600px by 600px image for the best view)": "Bännerpilt (parima vaate saamiseks kasutage pilti 16:6 või 1600 × 600 pikslit)",
    "Banner Title": "Bänneri pealkiri",
    "Enter here": "Sisestage siia",
    "Suggestion: Welcome to my community etc": "Soovitus: Tere tulemast minu kogukonda jne",
    "Banner Description": "Bänneri kirjeldus",
    "Enter banner description": "Sisestage bänneri kirjeldus",
    "Save Banner Info": "Salvestage bänneriteave",
    "Home Page Feed": "Avalehe voog",
    "Recent": "Viimased",
    "Top Posts": "Populaarseimad postitused",
    "Trending": "Trendikas",
    "Home Feed Groups": "Kodukanalite rühmad",
    "": "#VALUE!",
    "My Profile": "Minu profiil",
    "Logout": "Väljalogimine",
    "Notification": "Teavitus",
    "Notifications": "Märguanded",
    "Mark all viewed": "Märgi kõik vaadatud",
    "has created a post": "on loonud postituse",
    "wants to join": "tahab liituda",
    "has commented on your post": "on teie postitust kommenteerinud",
    "has replied to your comment": "on teie kommentaarile vastanud",
    "Search for tags": "Otsige silte",
    "All groups": "Kõik rühmad",
    "Search result": "Otsingu tulemus",
    "No post found for selected hashtag": "Valitud hashtagile ei leitud ühtegi postitust",
    "Start a conversation": "Alustage vestlust",
    "Search by name": "Otsi nime järgi",
    "Upcoming": "Tulemas",
    "UPCOMING": "TULEMAS",
    "Past": "Minevik",
    "PAST": "MINEVIK",
    "No upcoming events": "Tulevasi sündmusi pole",
    "Create event popup": "Loo sündmuse hüpikaken",
    "Event details": "Sündmuse üksikasjad",
    "16:9 aspect ratio": "16:9 kuvasuhe",
    "Event name": "Sündmuse nimi",
    "Enter event name": "Sisestage sündmuse nimi",
    "Host Name": "Hosti nimi",
    "You will be made host if none selected": "Kui ühtegi valitud ei ole, muudetakse teid hostiks",
    "Write here...": "Kirjuta siia...",
    "No. of registration for the event": "Üritusele registreerimise number",
    "Unlimited": "Piiramatu",
    "When & where": "Millal ja kus",
    "From": "Alates",
    "Start date": "Alguskuupäev",
    "time": "aega",
    "To": "To",
    "End date": "Lõppkuupäev",
    "Current time zone:": "Praegune ajavöönd:",
    "Can be updated from the communtiy setting": "Saab värskendada kogukonna seadetest",
    "Online event": "Online üritus",
    "Add meeting link": "Lisa koosoleku link",
    "Meeting link will be generated once event is created": "Koosoleku link luuakse pärast sündmuse loomist",
    "Venue": "Toimumiskoht",
    "Enter address": "Sisesta aadress",
    "Create": "Loo",
    "Invite": "Kutsu",
    "Share event via link": "Jaga sündmust lingi kaudu",
    "Copy__1": "Kopeeri",
    "Select section to post this event": "Valige selle sündmuse postitamiseks jaotis",
    "Once posted, members of that group or section will recieve an notification": "Pärast postitamist saavad selle rühma või jaotise liikmed teatise",
    "Post": "Postita",
    "RSVP": "RSVP",
    "Book Event": "Raamatu üritus",
    "Yes, I'll attend": "Jah, ma osalen",
    "May be": "Võib olla",
    "No, I won't attend": "Ei, ma ei osale",
    "Date & Time": "Kuupäev ja kellaaeg",
    "Host": "Host",
    "Online meeting": "Interneti-kohtumine",
    "Meeting link will be visible once registered for the event": "Koosoleku link on nähtav pärast üritusele registreerumist",
    "User Management": "Kasutajate haldamine",
    "Go bac to community": "Mine tagasi kogukonda",
    "Manage Members": "Liikmete haldamine",
    "Member": "liige",
    "Invited": "Kutsutud",
    "Search for member": "Otsi liiget",
    "Add to group": "Lisa gruppi",
    "Send Direct Message": "Saada otsesõnum",
    "Change role": "Muuda rolli",
    "Kick from community": "Kick kogukonnast",
    "Super Admin": "Superadministraator",
    "Super admin will have full access to the communtiy settings": "Superadministraatoril on täielik juurdepääs kogukonna seadetele",
    "Group Admin": "Grupi administraator",
    "Admin of the selected group can edit the group information and create, edt or delete section under selected group": "Valitud grupi administraator saab grupi teavet redigeerida ja valitud grupi all jaotist luua, redigeerida või kustutada",
    "Group Moderator": "Grupi moderaator",
    "Group moderator can create or delete post, comment, reply & messages in the selected group.": "Grupi moderaator saab valitud grupis postitusi, kommenteerida, vastata ja sõnumeid luua või kustutada.",
    "User": "Kasutaja",
    "Save": "Salvesta",
    "User role updated successfully": "Kasutaja rolli värskendamine õnnestus",
    "Leaderboard": "Edetabel",
    "Click on the column header for sorting": "Sortimiseks klõpsake veerupäisel",
    "Rank": "Aste",
    "Karma Points": "Karma punktid",
    "Custom Points": "Kohandatud punktid",
    "Follow": "Jälgi",
    "Upvotes": "Poolthääli",
    "Posts": "Postitused",
    "Add custom points": "Lisage kohandatud punkte",
    "Subtract custom points": "Lahutage kohandatud punktid",
    "Enter no. of points": "Sisestage nr. punktidest",
    "Add points": "Lisa punkte",
    "Invite members to": "Kutsuge liikmeid",
    "Invite via link": "Kutsu lingi kaudu",
    "Invite via email": "Kutsuge meili teel",
    "Add more": "Lisage veel",
    "Upload a CSV": "Laadige üles CSV",
    "Please upload a comma-seprated CSV file, with header as name, email.": "Laadige üles komadega eraldatud CSV-fail, mille päis on nimi, e-posti aadress.",
    "Here is a template CSV file": "Siin on CSV-faili mall",
    "Upload File": "Laadi fail üles",
    "Send Invite": "Saada kutse",
    "Mail Template": "Meili mall",
    "Send Test Mail": "Saada testpost",
    "Hey": "Tere",
    "A has invite you to join the B": "A kutsus teid B-ga liituma",
    "Switch to rich text editor": "Lülituge rikastekstiredaktorile",
    "Add Custom Message": "Lisa kohandatud sõnum",
    "Enter message here": "Sisesta siia sõnum",
    "Send Bulk Mail": "Saada hulgipostitus",
    "Send Mail": "Saada kiri",
    "Send bulk mail to all community members or select group members": "Saatke hulgipostitus kõigile kogukonna liikmetele või valitud rühmaliikmetele",
    "Date": "Kuupäev",
    "Subject": "Teema",
    "Recipients": "Saajad",
    "1000 bulk emails remaining for this month. Resets on <date>": "Selleks kuuks on jäänud 1000 hulgikirja. Lähtestab <kuupäev>",
    "Everyone": "Kõik",
    "Enter mail subject": "Sisestage kirja teema",
    "Write message": "Kirjutage sõnum",
    "Cancel__1": "Tühista",
    "Send": "Saada",
    "__1": "#VALUE!",
    "Activity": "Tegevus",
    "Bookmarks": "Järjehoidjad",
    "Edit Profile": "Redigeeri profiili",
    "Unsubscribe": "Loobu tellimusest",
    "Settings (Account)": "Seaded (konto)",
    "Profile": "Profiil",
    "Set Profile Picture": "Määra profiilipilt",
    "Your name": "Sinu nimi",
    "User ID": "Kasutaja ID",
    "Short bio": "Lühike biograafia",
    "Link your social account": "Linkige oma sotsiaalkonto",
    "This will be displayed on your profile": "See kuvatakse teie profiilil",
    "Add social handle": "Lisage suhtluskäepide",
    "Verification": "Kontrollimine",
    "Account Verification": "Konto kinnitamine",
    "Email": "Meil",
    "Enter email": "Sisestage e-posti aadress",
    "Verified": "Kinnitatud",
    "Unverified": "Kinnitamata",
    "Change": "Muuda",
    "Unlink": "Tühista linkimine",
    "Mobile": "Mobiilne",
    "enter mobile no.": "sisestage mobiili nr.",
    "Request OTP": "Taotlege OTP-d",
    "Manage your personal account notification preferences": "Hallake oma isikliku konto teavituse eelistusi",
    "Prefrences": "Eelistused",
    "Email notification": "E-posti teavitus",
    "Notify me about comments on my posts": "Anna mulle teada minu postituste kommentaaridest",
    "Notify me about replies on my comments": "Anna mulle teada minu kommentaaridele vastamisest",
    "Notify me about upvotes on my posts": "Teavita mind minu postitustele antud poolthäältest",
    "Notify me about reaction on my comments": "Teavita mind kommentaaridele reageerimisest",
    "Notify me about reaction on my reply": "Teavita mind minu vastusele reageerimisest",
    "Notify me about direct message": "Teavitage mind otsesõnumi kohta",
    "Notify me about my mentions": "Anna mulle minu mainimistest teada",
    "Notification for new posts": "Teade uute postituste kohta",
    "Only group & section available which you are part of": "Saadaval on ainult rühm ja jaotis, mille osa te olete",
    "Group & Section": "Rühm ja sektsioon",
    "All activity": "Kogu tegevus",
    "Post by admin": "Postitus administraatorilt",
    "No Notification": "Märguanne puudub",
    "Setting (Community)": "Seade (kogukond)",
    "General Settings": "Üldsätted",
    "Upload community logo": "Laadige üles kogukonna logo",
    "Community name": "kogukonna nimi",
    "Invalid field": "Vale väli",
    "Your community address": "Teie kogukonna aadress",
    "Fav icon": "Lemmik ikoon",
    "This will be visible on the browser tab (32px by 32px)": "See on nähtav brauseri vahekaardil (32 x 32 pikslit)",
    "TimeZone": "Ajavöönd",
    "Privacy Policy on login page": "Privaatsuspoliitika sisselogimislehel",
    "Terms & Condition on login page": "Tingimused sisselogimislehel",
    "Enter link here": "Sisesta link siia",
    "Open Group Image": "Avage rühmapilt",
    "By default ir takes up the community banner uploaded with the communtiy": "Vaikimisi kasutab ir koos kommuuniga üles laaditud kogukonna bänneri",
    "Community Experience": "kogukonna kogemus",
    "Onboarding": "Sissepääs",
    "Make your community private": "Muutke oma kogukond privaatseks",
    "Users will have to login or sign up to access the community": "Kasutajad peavad kogukonnale juurdepääsuks sisse logima või registreeruma",
    "Make account verification mandatory for both email & mobile": "Muutke konto kinnitamine kohustuslikuks nii meili kui ka mobiili jaoks",
    "New user will have to verify both email & mobile no. to access the community": "Uus kasutaja peab kinnitama nii e-posti kui ka mobiilinumbri. kogukonnale juurdepääsuks",
    "Admin will also have to verify their mobile no. & email or else they won't be able to access the community": "Administraator peab kinnitama ka oma mobiilinumbri. & meilisõnumiga või muidu ei pääse nad kogukonnale juurde",
    "Gated community access": "Piiratud kogukonna juurdepääs",
    "Admin will have to approve or reject user's requests to join the community": "Administraator peab kasutaja taotlused kogukonnaga liitumiseks heaks kiitma või tagasi lükkama",
    "Disable mobile login/register": "Keela mobiilne sisselogimine/registreerumine",
    "Disable email login/register": "Keela e-posti sisselogimine/registreerimine",
    "Disable google login/register": "Keela Google'i sisselogimine/registreerimine",
    "Disable facebook login/register": "Keela Facebooki sisselogimine/registreerimine",
    "Show & Hide features": "Funktsioonide näitamine ja peitmine",
    "Hide direct chat": "Peida otsevestlus",
    "User will not be able to send direct messages to each other": "Kasutajad ei saa üksteisele otsesõnumeid saata",
    "Hide profile picture from top right corner for mobile responsive view": "Peida profiilipilt paremast ülanurgast, et näha mobiilile reageerivat vaadet",
    "Useful when using community in an in app browser": "Kasulik kogukonna kasutamisel rakendusesiseses brauseris",
    "Hide profile picture from top right corner in every view": "Peida profiilipilt igas vaates paremast ülanurgast",
    "Disable header dropdown on profile picture": "Keela profiilipildil päise rippmenüü",
    "Useful for integrated community, especially using SSO": "Kasulik integreeritud kogukonna jaoks, eriti SSO-d kasutades",
    "Hide the communtiy logo from the header": "Peida kogukonna logo päisest",
    "Hide the communtiy title from the header": "Peida kogukonna pealkiri päisest",
    "Show collpased group in the side nav bar": "Kuva ahendatud rühm külgmisel navigeerimisribal",
    "Show full expanded post in the home feed": "Kuva täielik laiendatud postitus koduvoos",
    "Hide the leaderboard score from the header": "Peida edetabeli tulemus päisest",
    "Show powered by Pensil": "Show powered by Pensil",
    "Hide closed groups if not joined": "Peida suletud rühmad, kui pole liitunud",
    "Closed groups would not be shown to the user if they are not a member of the group": "Suletud gruppe ei näidata kasutajale, kui ta ei ole grupi liige",
    "Hide Community subscriber count from the users": "Peida kogukonna tellijate arv kasutajate eest",
    "This will hide the community subscriber list in the community header": "See peidab kogukonna tellijate loendi kogukonna päises",
    "Disable Communtiy Switcher": "Communtiy Switcheri keelamine",
    "Use MD editor for create post description": "Kasutage postituse kirjelduse loomiseks MD-redaktorit",
    "Non logged in user will land on explore group page instead of post directory": "Sisselogimata kasutaja jõuab postituste kataloogi asemel uurimisrühma lehele",
    "Advanced configurable": "Täpsemalt konfigureeritav",
    "Communtiy default country code": "Ühenduse riigi vaikekood",
    "This will show up by default on login/signup": "See kuvatakse sisselogimisel/registreerumisel vaikimisi",
    "Onboarding/Welcome Message": "Sisseastumis-/tervitusteade",
    "Welcome Message": "Tervitussõnum",
    "Greet your members with personalized message": "Tervitage oma liikmeid isikupärastatud sõnumiga",
    "Welcome to": "Tere tulemast",
    "Message": "Sõnum",
    "Add message": "Lisa sõnum",
    "Custom domain": "Kohandatud domeen",
    "Add custom domain": "Lisa kohandatud domeen",
    "Create new request": "Loo uus taotlus",
    "Enter your custom domain": "Sisestage oma kohandatud domeen",
    "Setup details": "Seadistuse üksikasjad",
    "Add a CNAME record in your domain pointing to this community's address": "Lisage oma domeeni CNAME-kirje, mis osutab selle kogukonna aadressile",
    "To configure your domain, you'll need to add a CNAME record pointing your domain to your pensil community URL": "Domeeni konfigureerimiseks peate lisama teie domeenile suunava CNAME-kirje teie pensili kogukonna URL-ile",
    "Step by Step help apge": "Samm-sammult abi lk",
    "All request list": "Kõik taotlused",
    "Allow admin to assign/un-assign custom points to users": "Luba administraatoril kasutajatele kohandatud punkte määrata/määramise tühistada",
    "Base points for user to begin with": "Alustuseks kasutajate baaspunktid",
    "Base points will be updated for all the users, any changes will reflect for all the users.": "Baaspunkte värskendatakse kõigi kasutajate jaoks, kõik muudatused kajastuvad kõigi kasutajate jaoks.",
    "Allocate points for interaction": "Jagage suhtlemiseks punkte",
    "Upvoting post": "Poolthääletav postitus",
    "creating a comment": "kommentaari loomine",
    "creating a reply": "vastuse loomine",
    "Getting upvote to their post": "Saab nende postituse poolthääle",
    "Getting comment to their post": "Kommentaari saamine nende postitusele",
    "Getting reply to their comment": "Nende kommentaarile vastuse saamine",
    "Creating a post": "Postituse loomine",
    "Visiblity": "Nähtavus",
    "Move Up": "Liigu üles",
    "Move Down": "Liigu alla",
    "Create embedded section": "Loo manustatud jaotis",
    "Preview area": "Eelvaate ala",
    "Theme selector": "Teema valija",
    "Community Theme": "Kogukonna teema",
    "Select theme": "Valige teema",
    "Select brand color": "Valige brändi värv",
    "Customize your button color to match your brand": "Kohandage oma nupu värvi vastavalt oma kaubamärgile",
    "Select on button text color": "Valige nupu teksti värv",
    "Suggestion: Keep inverted contrast against brand color": "Soovitus: säilitage vastupidine kontrast brändi värvi suhtes",
    "Billing": "Arveldamine",
    "Current plan": "Praegune plaan",
    "You are current on Free PLan": "Olete praegu tasuta PLanis",
    "Renew on: NA": "Uuenda: NA",
    "Select": "Valige",
    "Email us at": "Saatke meile e-kiri aadressil",
    "Compare plan": "Võrdle plaani",
    "API Keys": "API võtmed",
    "Create new key": "Loo uus võti",
    "Total keys": "Võtmed kokku",
    "Keep your API keys safe! You can use them to access specific feature & let cetain apps perfrom certain actions on your behalf on the platform.": "Hoidke oma API võtmed turvaliselt! Saate neid kasutada, et pääseda juurde konkreetsetele funktsioonidele ja lasta teatud rakendustel platvormil teie nimel teatud toiminguid teha.",
    "Key name": "Võtme nimi",
    "Key value": "Võtmeväärtus",
    "Action": "Tegevus",
    "Group updated!": "Gruppi värskendati!",
    "Are you sure you want to": "Kas olete kindel, et soovite",
    "Make Moderator": "Tee moderaatoriks",
    "Remove from group": "Eemalda grupist",
    "Show All": "Kuva kõik",
    "Change Role": "Muuda rolli",
    "Close": "Sule",
    "copy": "kopeerida",
    "LINKS": "LINGID",
    "Email Id": "E-posti ID",
    "Name": "Nimi",
    "Search for an image": "Otsige pilti",
    "Crop Image": "Kärbi pilti",
    "No photos found": "Fotosid ei leitud",
    "Community": "kogukond",
    "Banner ratio - 16:9": "Bänneri suhe – 16:9",
    "Banner Ratio - 16:6": "Bänneri suhe – 16:6",
    "Share on mail": "Jaga meili teel",
    "Share on Telegram": "Jaga Telegramis",
    "Share on Whatsapp": "Jagage Whatsappis",
    "Share on Linkedin": "Jagage Linkedinis",
    "Share on Facebook": "Jaga Facebookis",
    "Share on Twitter": "Jaga Twitteris",
    "Pin Post": "Kinnitage postitus",
    "Heading (optional)": "Pealkiri (valikuline)",
    "Select section": "Valige jaotis",
    "Gif": "Gif",
    "Create Custom Widget": "Loo kohandatud vidin",
    "Are you sure you want to delete this widget?": "Kas olete kindel, et soovite selle vidina kustutada?",
    "Go to event": "Mine sündmusele",
    "Add Tags": "Lisa sildid",
    "Create Tag": "Loo silt",
    "Title (Optional)": "Pealkiri (valikuline)",
    "Search Gif": "Otsi Gif",
    "What's on your mind": "Mis sul meeles on",
    "Looks like nothing available here right now.": "Näib, et siin pole praegu midagi saadaval.",
    "Try exploring other tabs": "Proovige uurida teisi vahekaarte",
    "Delete Widget": "Kustuta vidin",
    "Please select a section to post": "Valige postitamiseks jaotis",
    "Post added successfully!": "Postituse lisamine õnnestus!",
    "Failed to create post. Please check post content and retry again.": "Postituse loomine ebaõnnestus. Kontrollige postituse sisu ja proovige uuesti.",
    "Are you sure you want to discard current post?": "Kas olete kindel, et soovite praegusest postitusest loobuda?",
    "By default it will take up the image uploaded with the post": "Vaikimisi võtab see üles koos postitusega üles laaditud pildi",
    "Quiz can be only viewed and attempted from mobile device right now!": "Viktoriini saab praegu vaadata ja proovida ainult mobiilseadmest!",
    "Community Banner": "Kogukonna bänner",
    "Change Cover": "Vahetage katet",
    "Suggestions: Welcome to my community etc": "Soovitused: Tere tulemast minu kogukonda jne",
    "(edited)": "(redigeeritud)",
    "Aspect ratio (recommended)": "Kuvasuhe (soovitatav)",
    "Banner details updated!": "Bänneri üksikasju uuendatud!",
    "Refresh if changes are not visible!": "Värskendage, kui muudatusi pole näha!",
    "Banner details could not be updated!": "Bänneri üksikasju ei saanud värskendada!",
    "Post deleted": "Postitus kustutatud",
    "Post not available. It may have been deleted.": "Postitus pole saadaval. See võib olla kustutatud.",
    "Admin": "Admin",
    "Moderator": "Moderaator",
    "Bookmark added!": "Järjehoidja lisatud!",
    "Bookmark removed": "Järjehoidja eemaldatud",
    "Failed performing action!": "Toiming ebaõnnestus!",
    "Copy this link to share on other platforms": "Teistel platvormidel jagamiseks kopeerige see link",
    "View this event": "Vaadake seda sündmust",
    "Event": "Sündmus",
    "Join Meeting": "Liitu koosolekuga",
    "The live meeting has ended": "Otseülekanne on lõppenud",
    "read more...": "loe edasi...",
    "Load more comments": "Laadige rohkem kommentaare",
    "Post Reply": "Postita vastus",
    "Post Comment": "Postita kommentaar",
    "more": "rohkem",
    "upvoted": "poolthääletanud",
    "1 Upvote": "1 poolthääl",
    "1 Comment": "1 kommentaar",
    "Please enter a title": "Sisestage pealkiri",
    "Please enter a url link": "Sisestage URL-i link",
    "Please enter button title": "Sisestage nupu pealkiri",
    "Button label must be at least 20 characters": "Nupu silt peab olema vähemalt 20 tähemärki pikk",
    "Please enter valid url": "Sisestage kehtiv URL",
    "Suggestions: Know more, Join, Apply...": "Soovitused: uuri rohkem, liitu, kandideeri...",
    "URL": "URL",
    "Community Events": "Ühiskondlikud üritused",
    "Widget deleted successfully": "Vidina kustutamine õnnestus",
    "Community Top Contributors": "Kogukonna tipp-panustajad",
    "points": "punktid",
    "Points cannot be greater than current points": "Punktid ei tohi olla suuremad kui praegused punktid",
    "Point cannot be a negative value": "Punkt ei saa olla negatiivne väärtus",
    "Point cannot be a decimal point": "Punkt ei saa olla koma",
    "Please enter a valid number": "Sisestage kehtiv number",
    "Karma points updated successfully": "Karma punktide värskendamine õnnestus",
    "Error in updating karma points": "Viga karmapunktide värskendamisel",
    "Add karma points": "Lisage karma punkte",
    "Minus karma points": "Miinus karma punktid",
    "Total Karma points:": "Karma punktid kokku:",
    "Enter no. of karma points": "Sisestage nr. karma punktidest",
    "Minus Points": "Miinuspunktid",
    "Trending Post": "Populaarsust koguv postitus",
    "No visible description": "Nähtavat kirjeldust pole",
    "Picture ratio: 1:1": "Pildi suhe: 1:1",
    "home feed": "kodu sööt",
    "Event name is invalid!": "Sündmuse nimi on kehtetu!",
    "custom": "kohandatud",
    "Custom widget updated successfully": "Kohandatud vidina värskendamine õnnestus",
    "Name invalid!": "Nimi kehtetu!",
    "Current timezone:": "Praegune ajavöönd:",
    "can be updated from community settings": "saab värskendada kogukonna seadetest",
    "Event created successfully": "Sündmuse loomine õnnestus",
    "Error in creating event": "Viga sündmuse loomisel",
    "Attendees": "Osalejad",
    "Do you wish to notify these changes to attendees?": "Kas soovite nendest muudatustest osalejaid teavitada?",
    "users wants to attend this event": "kasutajad soovivad sellel sündmusel osaleda",
    "Yes, Notify them": "Jah, teavitage neid",
    "No, its okay": "Ei, see on korras",
    "Do you wish to notify that event is cancelled?": "Kas soovite teavitada, et üritus jääb ära?",
    "Are you sure you want to delete the event?": "Kas olete kindel, et soovite sündmuse kustutada?",
    "Delete Event": "Kustuta sündmus",
    "New Event": "Uus sündmus",
    "Accept Invitation": "Võta kutse vastu",
    "Requested": "Soovitud",
    "Declined": "Keeldutud",
    "Request Access": "Taotle juurdepääsu",
    "Enroll for": "Registreeruge",
    "Housefull": "Majatäis",
    "Just copy paste this code wherever you want it to be embedded:": "Lihtsalt kopeerige ja kleepige see kood sinna, kuhu soovite selle manustada:",
    "Ended": "Lõppenud",
    "Error getting events": "Viga sündmuste hankimisel",
    "Events could not be fetched!": "Sündmusi ei saanud tuua!",
    "Show Attendees": "Näita osalejaid",
    "Subscribers": "Tellijad",
    "Make this a closed section": "Muutke see suletud jaotiseks",
    "Update Section": "Uuenda jaotist",
    "Valid section name required!": "Nõutav kehtiv jaotise nimi!",
    "Enter section name": "Sisestage jaotise nimi",
    "Community Admin": "Kogukonna administraator",
    "Embed": "Manusta",
    "Invite to": "Kutsu",
    "Please enter a valid email address": "Sisestage kehtiv e-posti aadress",
    "Invitation sent successfully": "Kutse saadeti edukalt",
    "Error sending invitation": "Viga kutse saatmisel",
    "Email is not valid!": "E-post ei kehti!",
    "Data could not be loaded!": "Andmeid ei saanud laadida!",
    "Posted in": "Postitatud",
    "Invite Members Individually": "Kutsuge liikmeid individuaalselt",
    "Start a discussion": "Alustage arutelu",
    "Post something": "Postitage midagi",
    "Invite your audience": "Kutsu oma publik",
    "Choose Plan": "Valige Plaan",
    "or": "või",
    "Create a link": "Loo link",
    "Add link": "Lisa link",
    "Update link": "Värskenda linki",
    "Add shortcut to your most used tools": "Lisage otsetee oma enimkasutatud tööriistadele",
    "Your website, Instagram Channel, Facebook profile etc": "Teie veebisait, Instagrami kanal, Facebooki profiil jne",
    "Valid link name required!": "Nõutav kehtiv lingi nimi!",
    "Valid url required, and make sure you are not missing http:// or https://": "Nõutav on kehtiv URL ja veenduge, et teil pole puudu http:// või https://",
    "Invite to__1": "Kutsu",
    "Link Name": "Lingi nimi",
    "Link URL": "Lingi URL",
    "Could not subscribe to": "Ei saanud tellida",
    "Subscribed to": "Tellitud",
    "By default it will take up the community banner uploaded with the community": "Vaikimisi võtab see üles koos kogukonnaga üles laaditud kogukonna bänneri",
    "Created by": "Loodud",
    "Online Event (Meeting link will be visible once registered for the event)": "Veebisündmus (Koosoleku link on nähtav pärast üritusele registreerumist)",
    "Join Call": "Liitu kõnega",
    "Please login to book this event": "Selle ürituse broneerimiseks logige sisse",
    "Commented on": "kommenteeris",
    "Replied to": "Vastas",
    "Looks like it's lonely here.": "Tundub, et siin on üksildane.",
    "Try exploring other sections and groups.": "Proovige uurida teisi jaotisi ja rühmi.",
    "Please proceed with the payment or contact admin to gain access to this group.": "Sellele grupile juurdepääsu saamiseks jätkake maksega või võtke ühendust administraatoriga.",
    "This is a closed group You'll need access to this group.": "See on suletud grupp Teil on vaja sellele grupile juurdepääsu.",
    "You have no bookmarks right now.": "Teil pole praegu järjehoidjaid.",
    "The user hasn't posted anything yet publicly.": "Kasutaja pole veel midagi avalikult postitanud.",
    "No activity to show.": "Kuvatavat tegevust pole.",
    "Are you sure you want to unsubscribe the community?": "Kas olete kindel, et soovite kogukonna tellimusest loobuda?",
    "deals left": "pakkumised jäänud",
    "Something went wrong while loading posts": "Midagi läks postituste laadimisel valesti",
    "Could not unsubscribe from": "Tellimust ei saanud tühistada",
    "Unsubscribed from": "Tellimusest loobuti",
    "Login to view this page": "Selle lehe vaatamiseks logige sisse",
    "Login": "Logi sisse",
    "There was some error while doing the action!": "Toimingu tegemisel ilmnes viga!",
    "Unable to delete section!": "Jaotist ei saa kustutada!",
    "__2": "",
    "__3": "",
    "__4": "",
    "Home page": "Avaleht",
    "Members Directory": "Liikmete kataloog",
    "Calendar": "Kalender",
    "Create Group": "Loo rühm",
    "Start Live Session": "Alusta reaalajas seanssi",
    "Home__1": "Kodu",
    "Following": "Jälgides",
    "__5": "",
    "Post Card": "Postkaart",
    "Like": "meeldib",
    "Comment__1": "kommenteerida",
    "Comment__2": "kommenteerida",
    "Share__1": "Jaga",
    "Report": "Teata",
    "Follow User": "Jälgi kasutajat",
    "Report User": "Teata kasutajast",
    "Report Post": "Teata postitusest",
    "__6": "",
    "LeaderBoard Floating pop up": "Edetabel Ujuv hüpikaken",
    "Go to leaderboard": "Mine edetabelisse",
    "Total karma points": "Karma punktid kokku",
    "Comments__1": "Kommentaarid",
    "Upvotes__1": "Poolthääli",
    "Replies__1": "Vastused",
    "Post__1": "Postita",
    "Custom Points__1": "Kohandatud punktid",
    "Base Points": "Baaspunktid",
    "__7": "",
    "Channel": "Kanal",
    "This is a private channel": "See on privaatne kanal",
    "You'll need access to this channel": "Teil on vaja juurdepääsu sellele kanalile",
    "__8": "",
    "Profile Page": "Profiilileht",
    "Followers": "Jälgijad",
    "Activities": "Tegevused",
    "__9": "",
    "Settings Page": "Seadete leht",
    "Go back to community": "Mine tagasi kogukonda",
    "Account": "konto",
    "Notification Centre": "Teavituskeskus",
    "__10": "",
    "Edit Profile Page": "Redigeeri profiililehte",
    "Set profile Picture": "Määra profiilipilt",
    "Your name__1": "Sinu nimi",
    "Subtitle": "Alapealkiri",
    "(Max char 60)": "(Max 60 tähemärki)",
    "User Id": "Kasutaja ID",
    "Short Bio": "Lühike biograafia",
    "Link For Social Account": "Link sotsiaalkonto jaoks",
    "This will be displayed on your profile__1": "See kuvatakse teie profiilil",
    "Add Social handles": "Lisage suhtluskäepidemed",
    "__11": "",
    "Verification Page": "Kinnitusleht",
    "Email__1": "Meil",
    "Verified__1": "Kinnitatud",
    "__12": "",
    "Manage your personal account notification preferences__1": "Hallake oma isikliku konto teavituse eelistusi",
    "Preferences": "Eelistused",
    "Email Notification": "E-posti teavitus",
    "Notify me about comment on my posts": "Anna mulle teada minu postituste kommenteerimisest",
    "Notify me about replies on my comment": "Teavita mind minu kommentaarile vastamisest",
    "Notify me about upvote on my post": "Teavita mind minu postituse poolthääle andmisest",
    "Notify me about reaction to my comment": "Teavita mind minu kommentaarile reageerimisest",
    "Notify me about reaction on my reply__1": "Teavita mind minu vastusele reageerimisest",
    "Notify me about direct message__1": "Teavitage mind otsesõnumi kohta",
    "Notify me about mentions": "Anna mulle mainimisest teada",
    "Notification for new posts__1": "Teade uute postituste kohta",
    "Only groups and channel available which you are part of. You can also control notification": "Saadaval on ainult rühmad ja kanal, mille osa te olete. Saate ka märguandeid juhtida",
    "Group & Channels": "Grupp ja kanalid",
    "All Activity": "Kõik tegevused",
    "Post by admin__1": "Postitus administraatorilt",
    "No Notification__1": "Märguanne puudub",
    "__13": "",
    "Direct Message__1": "Otsesõnum",
    "Inbox": "Postkast",
    "No chats found": "Vestlusi ei leitud",
    "__14": "",
    "Create Post Popup": "Loo postituse hüpikaken",
    "Create Post in": "Loo postitus sisse",
    "Select Channel": "Valige Kanal",
    "__15": "",
    "Dark Mode": "Tume režiim",
    "__16": "",
    "has created a post in": "on loonud postituse riigis",
    "joined": "liitunud",
    "wants to join__1": "tahab liituda",
    "liked your post!": "meeldis su postitus!",
    "has commented on your post in": "on kommenteerinud teie postitust kohas",
    "has replied to your comment on a post in": "on vastanud teie kommentaarile postituse kohta",
    "has mentioned you in a post in": "on teid maininud postituses aastal",
    "has mentioned you in a comment": "on teid kommentaaris maininud",
    "has mentioned you in a reply": "on teid vastuses maininud"
}